import { createContext, useReducer, useContext } from 'react'
import { TSnackbarContextState } from '../constants/types';


const initialState: TSnackbarContextState = {
    message: null,
    error: false,
}

// Actions
interface setSnackbar { type: 'setSnackbar'; payload: TSnackbarContextState }
interface clearSnackbar { type: 'clearSnackbar' }

type Action = setSnackbar | clearSnackbar;

// Reducer
export type SnackbarContextState = { snackbar: TSnackbarContextState | null | undefined}
type Dispatch = (action: Action) => void;

function userReducer(state: SnackbarContextState, action: Action): SnackbarContextState {
    switch (action.type) {
        case 'setSnackbar':
            return {snackbar: action.payload}
        case 'clearSnackbar':
            return {snackbar: initialState}
        default:
            return state        
    }
}

// Context
const SnackbarContext = createContext<{ snackbarDispatch: Dispatch } & SnackbarContextState | undefined>(undefined)

// Provider 
function SnackbarProvider({ children }: { children: React.ReactNode }) {
    const [state, dispatch] = useReducer(userReducer, {snackbar: initialState})
    
    const value = { ...state, snackbarDispatch: dispatch }

    return (
        <SnackbarContext.Provider value={value}>
            {children}
        </SnackbarContext.Provider>
    )
}

// Hook to consume channel data
function useSnackbar() {
    const context = useContext(SnackbarContext)
    if (context === undefined) throw new Error('useSnackbar must be used within a SnackbarProvider')
    return context
}

export { SnackbarProvider, useSnackbar }